import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Menu } from '@linktivity/link-ui';
import { useStore } from '@/stores';
import { PAYMENT_FILTERS_TYPE, ACTIVE_TAB } from '@/constants';
import styles from './sidebar.module.css';

const Sidebar = () => {
  const { t } = useTranslation();
  const { tenants } = useStore();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.inner}>
        <Menu className={styles.menu} accordion>
          <Menu.MenuItem label={t('views.dashboard.title')} to="/dashboard" />
          <Menu.MenuItem
            label={t('views.payment.title')}
            to={`${tenants.tenantId}/payment?${ACTIVE_TAB}=${PAYMENT_FILTERS_TYPE.List}`}
          />
        </Menu>
      </div>
    </aside>
  );
};
const ObserverSidebar = observer(Sidebar);
export default ObserverSidebar;
